import { FC } from 'react';
import { Colors, FInter, FlexBox } from '@brg/ui';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LayoutConst } from 'core';
import { RectangularButtonFilled } from 'shared/components/buttons';
import { useHistory } from 'react-router-dom';

const OuterWrapper = styled(FlexBox)`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.ageModal?.bg || '#FEFEFE'};
`;

const Wrapper = styled(FlexBox)`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 32px 40px 40px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    padding: 24px 16px;
    gap: 24px;
  }
`;

const Title = styled(FInter.SectionTitle)`
  letter-spacing: -0.6px;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  color: ${({ theme }) => theme.not_saved_modal?.title || '#151514'};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    font-style: normal;
    font-weight: 600;
    line-height: 29px;
    letter-spacing: -0.46px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: normal;
  }
`;

const Description = styled(FInter.SectionTitle)`
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.34px;
  color: ${({ theme }) => theme.not_saved_modal?.title || '#909090'};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: normal;
  }
`;

const ButtonWrapper = styled(FlexBox)`
  width: 100%;
  max-width: 400px;
  justify-content: center;
`;

const BackButton = styled(RectangularButtonFilled)`
  width: 100%;
  height: 46px !important;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 15px;
    line-height: 20px;
    height: 40px !important;
  }
`;

export const BlockedProjectModal: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleBack = () => {
    history.goBack();
  };

  return (
    <OuterWrapper onClick={(e) => e.stopPropagation()}>
      <Wrapper onClick={(e) => e.stopPropagation()}>
        <Title>{t('blocked_project_modal.title')}</Title>
        <Description>{t('blocked_project_modal.description')}</Description>
        <ButtonWrapper>
          <BackButton onClick={handleBack}>
            {t('blocked_project_modal.back_button')}
          </BackButton>
        </ButtonWrapper>
      </Wrapper>
    </OuterWrapper>
  );
};

import { FC } from 'react';
import { Colors, FInter, FlexBox } from '@brg/ui';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LayoutConst } from 'core';
import { RectangularButtonFilled } from 'shared/components/buttons';
import { useHistory } from 'react-router-dom';

const OuterWrapper = styled(FlexBox)`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.ageModal?.bg || '#FEFEFE'};
`;

const Wrapper = styled(FlexBox)`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 32px 40px 40px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    padding: 24px 16px;
    gap: 24px;
  }
`;

const Title = styled(FInter.SectionTitle)`
  letter-spacing: -0.6px;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  color: ${({ theme }) => theme.not_saved_modal?.title || '#151514'};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    font-style: normal;
    font-weight: 600;
    line-height: 29px;
    letter-spacing: -0.46px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: normal;
  }
`;

const Description = styled(FInter.SectionTitle)`
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.34px;
  color: ${({ theme }) => theme.not_saved_modal?.title || '#909090'};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: normal;
  }
`;

const ButtonWrapper = styled(FlexBox)`
  width: 100%;
  max-width: 400px;
  justify-content: center;
`;

const BackButton = styled(RectangularButtonFilled)`
  width: 100%;
  height: 46px !important;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 15px;
    line-height: 20px;
    height: 40px !important;
  }
`;

export const BlockedProjectModal: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleBack = () => {
    history.goBack();
  };

  return (
    <OuterWrapper onClick={(e) => e.stopPropagation()}>
      <Wrapper onClick={(e) => e.stopPropagation()}>
        <Title>{t('blocked_project_modal.title')}</Title>
        <Description>{t('blocked_project_modal.description')}</Description>
        <ButtonWrapper>
          <BackButton onClick={handleBack}>
            {t('blocked_project_modal.back_button')}
          </BackButton>
        </ButtonWrapper>
      </Wrapper>
    </OuterWrapper>
  );
};

